<template>
  <div id="app-HR">
    <div class="hr_container">
      <div class="hr_index">
        <div class="hr_img_containel">
          <div class="hr_img">
            <img src="@/assets/hr/banner.png" alt="" />
          </div>
        </div>
        <div class="hr_menus_list">
          <div
            class="hr_menus_item"
            v-for="(item, index) in menusList"
            :key="index"
            @click="jumpPage(item)"
          >
            <img :src="item.bgdImg" alt="">
            <div class="content_text">
              <div class="ch_name">{{ item.ch_name }}</div>
              <div class="en_name">{{ item.en_name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HR",
  data() {
    return {
      menusList: [
        {
          en_name: "Position Management",
          ch_name: "职位管理",
          bgdImg: require('@/assets/hr/PositionManagement.png'),
          path: "/HR/position",
        },
        {
          en_name: "Delivery Record",
          ch_name: "投递记录",
          bgdImg: require('@/assets/hr/DeliveryRecord.png'),
          path: "/HR/deliveryRecord",
        },
        {
          en_name: "kan Ban",
          ch_name: "内推/自荐看板",
          bgdImg: require('@/assets/hr/kanBan.png'),
          path: "/HR/internal",
        },
        {
          en_name: "Interview Management",
          ch_name: "面试管理",
          bgdImg: require('@/assets/hr/InterviewManagement.png'),
          path: "/HR/interviewManagement",
        },
        {
          en_name: "Talent Pool",
          ch_name: "人才库",
          bgdImg: require('@/assets/hr/TalentPool.png'),
          path: "/HR/talentPool",
        },
        {
          en_name: "I recommend",
          ch_name: "我要推荐",
          bgdImg: require('@/assets/hr/recommend.png'),
          path: "/mobile/insideRecommend",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    //跳转到详情
    jumpPage(item) {
      if (item.path == '/mobile/insideRecommend') {
        location.href = `/mobile/insideRecommend?authority=false`
      } else {
        this.$router.push({
          path: item.path,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #app-HR {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #app-HR {
    width: 276px * $zoom;
  }
}
#app-HR {
  font-size: 16px * $zoom;
  position: relative;
  .hr_container {
    width: 100%;
    height: 100vh;
    background: #f7f9fa;
    .hr_index {
      width: 100%;
      height: 100%;
      .hr_img_containel {
        width: 100%;
        height: 400px;
        padding: 24px 32px;
        background: linear-gradient(180deg, #5CC385 0%, rgba(104,224,174,0) 100%);
        .hr_img {
          width: 100%;
          height: 328px;
          border-radius: 10px;
          background: #ccc;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .hr_menus_list {
        padding: 0 32px;
        .hr_menus_item {
          position: relative;
          float: left;
          width: 50%;
          height: 314px;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
          .content_text {
            position: absolute;
            left: 52px;
            top: 168px;
            .ch_name {
              font-size: 32px;
              font-weight: bold;
              color: #282B32;
            }
            .en_name {
              margin-top: 8px;
              font-size: 24px;
              font-weight: bold;
              color: #969B9E;
            }
          }
        }
      }
    }
  }
}
</style>
